import { IconHP } from 'legacy/lut/assets/img/icons/IconHP'
import React from 'react'

import styles from './SimplePageLayout.module.scss'

interface IProps {
  children: React.ReactNode
}

export const SimplePageLayout = ({ children }: IProps) => {
  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.logo}>
          <IconHP className={styles.logoIcon} />
        </div>
      </header>
      <div className={styles.divider} />
      <div className={styles.body}>{children}</div>
      <div className={styles.divider} />
    </div>
  )
}
